import { render, staticRenderFns } from "./folderDetails.vue?vue&type=template&id=402a01c1&scoped=true"
import script from "./folderDetails.vue?vue&type=script&lang=js"
export * from "./folderDetails.vue?vue&type=script&lang=js"
import style0 from "./folderDetails.vue?vue&type=style&index=0&id=402a01c1&prod&lang=scss&scoped=true"
import style1 from "./folderDetails.vue?vue&type=style&index=1&id=402a01c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402a01c1",
  null
  
)

export default component.exports